import { render, staticRenderFns } from "./NotificationBucketSelector.vue?vue&type=template&id=fa3e0268&scoped=true"
import script from "./NotificationBucketSelector.vue?vue&type=script&lang=js"
export * from "./NotificationBucketSelector.vue?vue&type=script&lang=js"
import style0 from "./NotificationBucketSelector.vue?vue&type=style&index=0&id=fa3e0268&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3e0268",
  null
  
)

export default component.exports